import area from "./area";

export default {
  data() {
    return {
      countryOptions: Object.keys(area),
    };
  },
  created() {
    this.countryOptions = [
      {
        label: this.countryOptions[0],
        value: this.countryOptions[0],
      },
      {
        label: this.countryOptions[1],
        value: this.countryOptions[1],
      },
    ];
  },
  computed: {
    stateOptions() {
      return area[this.form.regisState];
    },
    stateOptions2() {
      return area[this.form.insuranceRegisState];
    },
  },
  watch: {
    stateOptions(arr) {
      if (
        arr &&
        this.form.regisProvince &&
        !arr.includes(this.form.regisProvince)
      ) {
        // this.form.regisProvince = undefined;
      }
      arr.forEach((element, index) => {
        if (!element.label) {
          arr[index] = {};
          arr[index] = {
            label: element,
            value: element,
          };
        }
      });
    },
    stateOptions2(arr) {
      if (
        arr &&
        this.form.insuranceRegisProvince &&
        !arr.includes(this.form.insuranceRegisProvince)
      ) {
        // this.form.insuranceRegisProvince = undefined;
      }
      arr.forEach((element, index) => {
        if (!element.label) {
          arr[index] = {};
          arr[index] = {
            label: element,
            value: element,
          };
        }
      });
    },
  },
};
